var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderwater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Underwater") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M38.5 23.589v14.963a9.61 9.61 0 0 0-1-.052c-.768 0-1.47.289-2 .764V23.232c.986.103 1.986.222 3 .357zm-21-.22a57.79 57.79 0 0 1 3-.351v10.746a2.989 2.989 0 0 0-2-.764 9.61 9.61 0 0 0-1 .052v-9.683zm9-.619V42.5a8 8 0 1 1-8-8 1.5 1.5 0 0 1 0 3 5 5 0 1 0 5 5V22.817a70.845 70.845 0 0 1 3-.067zm6 .218V48a5 5 0 1 0 5-5 1.5 1.5 0 0 1 0-3 8 8 0 1 1-8 8V22.804c.985.037 1.985.091 3 .164zm6.607 21.922a5.024 5.024 0 0 0 1.63 1.778c.17.41.263.86.263 1.332 0 .698-.205 1.349-.557 1.895a8.011 8.011 0 0 1-4.833-6.065c.516.419 1.174.67 1.89.67.58 0 1.126.14 1.607.39zm7.728 1.336A5 5 0 0 0 43.5 37.5a1.5 1.5 0 0 1 0-3 8 8 0 0 1 3.335 15.274 9.552 9.552 0 0 0 0-3.548zM9.018 41.912a5 5 0 0 0 4.263 8.528 9.443 9.443 0 0 0 3.991 1.481 8 8 0 1 1-7.046-14.094 9.444 9.444 0 0 0-1.208 4.085zm8.47 3.94c.008-.117.012-.234.012-.352v-6.355a3.5 3.5 0 0 1 1-.145c.768 0 1.47-.289 2-.764v7.137a3.5 3.5 0 0 1-3.012.479z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M45.5 15c0-6.407-7.815-12-17.5-12-9.685 0-17.5 5.593-17.5 12 0 1.74.5 3.356 1.501 4.832 9.003-2.13 19.665-2.106 31.987.053C45.04 18.428 45.5 16.898 45.5 15zm-1.268 7.976c-12.66-2.298-23.447-2.298-32.361-.023A1.5 1.5 0 0 1 11.5 23h-.125a1.5 1.5 0 0 1-1.163-.552C8.424 20.254 7.5 17.726 7.5 15 7.5 6.679 16.833 0 28 0s20.5 6.679 20.5 15c0 2.883-.854 5.267-2.733 7.473-.31.364-.757.543-1.201.526a1.505 1.505 0 0 1-.334-.023z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h56v56H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderwater);
export default __webpack_public_path__ + "static/media/underwater.5ca93e5e59eb60932c9283953b8836c4.svg";
export { ForwardRef as ReactComponent };